var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.05 9.2-1.4-1.4-5.6 5.7-5.6-5.7-1.5 1.3 7.1 7.1 7-7Z",
    fill: "#333"
  })));
};
export { SvgChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOS4wNSA5LjE5OTk5TDE3LjY1IDcuNzk5OTlMMTIuMDUgMTMuNUw2LjQ1MDAxIDcuNzk5OTlMNC45NTAwMSA5LjA5OTk5TDEyLjA1IDE2LjJMMTkuMDUgOS4xOTk5OVoiIGZpbGw9IiMzMzMzMzMiLz4KPC9zdmc+Cg==";